import { render, staticRenderFns } from "./ContractorActivityCardNew.vue?vue&type=template&id=03745c7f"
import script from "./ContractorActivityCardNew.vue?vue&type=script&lang=ts"
export * from "./ContractorActivityCardNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03745c7f')) {
      api.createRecord('03745c7f', component.options)
    } else {
      api.reload('03745c7f', component.options)
    }
    module.hot.accept("./ContractorActivityCardNew.vue?vue&type=template&id=03745c7f", function () {
      api.rerender('03745c7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/activities/ContractorActivityCardNew.vue"
export default component.exports